export default __webpack_public_path__ + "static/media/ic_social.abb284d9.svg";